export const UPLOAD_PRODUCT_IMAGES = 'UPLOAD_PRODUCT_IMAGES';
export const UPLOAD_PRODUCT_IMAGES_SUCCESS = 'UPLOAD_PRODUCT_IMAGES_SUCCESS';
export const UPLOAD_PRODUCT_IMAGES_FAIL = 'UPLOAD_PRODUCT_IMAGES_FAIL';
export const UPLOAD_PRODUCT_IMAGES_RESET = 'UPLOAD_PRODUCT_IMAGES_RESET';